import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'

interface ProtectedRouteProps {
	children: ReactNode
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
	const { isAuthenticated, isLoading } = useAuth()
	const location = useLocation()

	if (isLoading) {
		return (
			<div className="min-h-screen flex items-center justify-center">
				<div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900" />
			</div>
		)
	}

	if (!isAuthenticated) {
		// Carry the original target so LoginPage can stash it before the Entra
		// round-trip. /login is whitelisted as a non-target so we don't bounce
		// users back to the login page after they sign in.
		const target = `${location.pathname}${location.search}`
		const from = target === '/login' ? null : target
		return <Navigate to="/login" replace state={from ? { from } : undefined} />
	}

	return <>{children}</>
}
